import { Link } from "react-router-dom";

function ProjectCard({ data }: any) {
  const { id, name, imageUrl } = data;

  return (
    <Link to={`/art/${id}`}>
      <img
        src={imageUrl}
        alt={name}
        className="w-full rounded-md shadow-xl transition-transform duration-1000 ease-in-out hover:cursor-pointer md:hover:scale-105"
      />
      {/* 
        <span className="text-xl md:text-2xl font-black text-black font-boska">
          {name.substring(0, 15)}
          {name.length > 15 && (
            <span className="font-sans font-light text-gray-500">...</span>
          )}
        </span> */}
    </Link>
  );
}

export default ProjectCard;
